import React, { useEffect, useState } from "react";
import "./DraftInvoice.css";
import { useNavigate, useLocation } from "react-router-dom";
import ApiManager from '../../ApiManager/ApiManager';

const DraftInvoice = () => {
    const [draftId, setDraftId] = useState("");
    const [draftHtml, setDraftHtml] = useState("");
    const [appliedTaxes, setAppliedTaxes] = useState([]);
    const [nonAppliedTaxes, setNonAppliedTaxes] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    const { companyId, tripIds, timeFrom, timeTo } = location.state || {companyId: 1, tripIds: [1], timeFrom: 0, timeTo: 0};

    useEffect(() => {
        const fetchBillDraft = async () => {
            try {
                // Simulate a request payload
                const requestPayload = {
                    companyId: companyId,
                    tripIds: tripIds,
                    timeFrom: timeFrom,
                    timeTo: timeTo
                };

                console.log("Request Payload:", requestPayload);

                // Dummy response
                const draftInvoiceResponse = await ApiManager.createDraftInvoice(requestPayload);
                const response = await draftInvoiceResponse.json();

                // Directly use the response object
                setDraftId(response.draftId);
                setDraftHtml(response.draftHtml);
                setAppliedTaxes(response.appliedTaxes || []);
                setNonAppliedTaxes(response.nonAppliedTaxes || []);
            } catch (error) {
                console.log("Error fetching bill draft", error);
            }
        };

        fetchBillDraft();
    }, [companyId, tripIds, timeFrom, timeTo]);

    const handleAddTax = async(tax) => {
        setAppliedTaxes((prevAppliedTaxes) => {
            const updatedAppliedTaxes = [...prevAppliedTaxes, tax];
            return updatedAppliedTaxes;
        });
    
        setNonAppliedTaxes((prevNonAppliedTaxes) =>
            prevNonAppliedTaxes.filter((t) => t.id !== tax.id)
        );
    
        try {
            const taxTypeIDs = [...appliedTaxes, tax].map((t) => t.id);
            const requestPayload = {
                draftId: draftId,
                taxtypeIds: taxTypeIDs,
            };
    
            const editDraftInvoiceResponse = await ApiManager.editDraftInvoice(requestPayload);
            const editedInvoice = await editDraftInvoiceResponse.json();

            setDraftHtml(editedInvoice.draftHtml);
            setDraftId(editedInvoice.draftId);
    
            console.log("Updated Invoice:", editedInvoice);
        } catch (error) {
            console.log("Error creating final invoice", error);
        }
    };

    const handleRemoveTax = async (tax) => {
        try {
            const updatedAppliedTaxes = appliedTaxes.filter((t) => t.id !== tax.id);
            
            const taxTypeIDs = updatedAppliedTaxes.map((t) => t.id);
    
            const requestPayload = {
                draftId: draftId,
                taxtypeIds: taxTypeIDs,
            };
    
            const editDraftInvoiceResponse = await ApiManager.editDraftInvoice(requestPayload);
            const editedInvoice = await editDraftInvoiceResponse.json();

            setDraftHtml(editedInvoice.draftHtml);
            setDraftId(editedInvoice.draftId);

            setAppliedTaxes(editedInvoice.appliedTaxes || updatedAppliedTaxes);
            setNonAppliedTaxes((prevNonAppliedTaxes) => [...prevNonAppliedTaxes, tax]);
    
            console.log("Updated Invoice:", editedInvoice);
        } catch (error) {
            console.log("Error removing tax from invoice", error);
        }
    };

    const handleCreateInvoice = async () => {
        try {
            const taxTypeIDs = appliedTaxes.map(tax => tax.id);
            const requestPayload = {
                draftId: draftId,
                taxtypeIds: taxTypeIDs
            };

            const finalInvoiceResponse = await ApiManager.createFinalInvoice(requestPayload);
            const finalInvoice = await finalInvoiceResponse.json();
            // console.log("Final Invoice:", finalInvoice);
            navigate("/login/final-invoice", { state: { invoiceNumber: finalInvoice.invoiceNumber, finalHtml: finalInvoice.finalHtml } });
        } catch (error) {
            console.log("Error creating final invoice", error);
        }
    };

    return (
        <div className="draft-invoice-container">
            <h1>Draft Invoice</h1>
            <div className="draft-id">
                <strong>Draft ID:</strong> {draftId}
            </div>
            <div className="bill-html" dangerouslySetInnerHTML={{ __html: draftHtml }}></div>
            <div className="taxes-container">
                <div className="included-taxes">
                    <h2>Included Taxes</h2>
                    <ul>
                        {appliedTaxes.map((tax) => (
                            <li key={tax.id}>
                                {tax.name} ({tax.rate}%)
                                <button onClick={() => handleRemoveTax(tax)}>Remove</button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="non-included-taxes">
                    <h2>Non-Included Taxes</h2>
                    <ul>
                        {nonAppliedTaxes.map((tax) => (
                            <li key={tax.id}>
                                {tax.name} ({tax.rate}%)
                                <button onClick={() => handleAddTax(tax)}>Add</button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="create-invoice-container">
                <button className="create-invoice-button" onClick={handleCreateInvoice}>
                    Create Invoice
                </button>
            </div>
        </div>
    );
};

export default DraftInvoice;